import { IconType } from 'react-icons';
import { duotone, regular } from 'virtual:phosphor-eager';
import { customDuotone, customRegular } from './customIcons';
import { LUCIDE_TO_PHOSPHOR } from './lucideToPhosphor';

/** The Phosphor weights bundled up front; the others live in the lazy "phosphor-…" picker pack. */
export type PhosphorWeight = 'regular' | 'duotone';

// Our own Phosphor-style icons sit beside the pack's; a Phosphor icon of the same name wins.
const ICONS_BY_WEIGHT: Record<PhosphorWeight, Record<string, IconType>> = {
  regular: { ...customRegular, ...regular },
  duotone: { ...customDuotone, ...duotone },
};

const hasOwn = (record: object, key: string) => Object.prototype.hasOwnProperty.call(record, key);

export const PHOSPHOR_ICON_NAMES = Object.keys(ICONS_BY_WEIGHT.duotone).sort((a, b) => a.localeCompare(b));

/** The Phosphor icon for a bare name — Phosphor ("Warning") or legacy Lucide ("AlertTriangle"). */
export function getPhosphorIcon(name: string, weight: PhosphorWeight): IconType | null {
  const phosphorName = hasOwn(LUCIDE_TO_PHOSPHOR, name) ? LUCIDE_TO_PHOSPHOR[name] : name;
  const icons = ICONS_BY_WEIGHT[weight];

  return hasOwn(icons, phosphorName) ? icons[phosphorName] : null;
}

/** A bundled icon for a react-icons Phosphor export name ("PiHouse", "PiHouseDuotone"); null for other weights. */
export function getBundledPhosphorExport(exportName: string): IconType | null {
  const name = exportName.replace(/^Pi/, '');
  if (name.endsWith('Duotone') && hasOwn(duotone, name.slice(0, -'Duotone'.length))) return duotone[name.slice(0, -'Duotone'.length)];

  return hasOwn(regular, name) ? regular[name] : null;
}
